import createCachedSelector from 're-reselect'
import { selectPlans } from './selectPlans'

export const selectPlansByProduct = createCachedSelector(
  (_state, product) => product,
  selectPlans,
  (product, plans) => plans.filter(p => p.product === product)
)((_state, product) => product || 'unknown')
